/* jshint node:true */
'use strict';

var Router = require('react-router');
var History = Router.History;
var LocationActions = {
    /**
     * Indicates a new location is being pushed to the history stack.
     */
    PUSH: 'push',
    /**
     * Indicates the current location should be replaced.
     */
    REPLACE: 'replace',
    /**
     * Indicates the most recent entry should be removed from the history stack.
     */
    POP: 'pop'
};

var _listeners = [];
var _isListening = false;

function notifyChange(type) {
    var change = {
        path: HistoryLocation.getCurrentPath(),
        type: type
    };

    _listeners.forEach(function(listener) {
        /**
        * [change.type = null]
        * Triggers route reload, after navigating
        * to an external route and returning back to react-router.
        * This is because, the router state remains unchanged
        * on visiting an external route.
        **/
        if(history && history.state && (typeof history.state.pathname === 'undefined' || history.state.pathname === location.pathname)){
            change.type = null;
        }
        listener.call(HistoryLocation, change);
    });
}

function onPopState(event) {
    if (event.state === undefined) {
        return;
    } // Ignore extraneous popstate events in WebKit.

    notifyChange(LocationActions.POP);
}

/**
 * A Location that uses HTML5 history.
 */
var HistoryLocation = {

    addChangeListener: function addChangeListener(listener) {
        _listeners.push(listener);

        if (!_isListening) {
            if (window.addEventListener) {
                window.addEventListener('popstate', onPopState, false);
            } else {
                window.attachEvent('onpopstate', onPopState);
            }

            _isListening = true;
        }
    },

    removeChangeListener: function removeChangeListener(listener) {
        _listeners = _listeners.filter(function(l) {
            return l !== listener;
        });

        if (_listeners.length === 0) {
            if (window.addEventListener) {
                window.removeEventListener('popstate', onPopState, false);
            } else {
                window.removeEvent('onpopstate', onPopState);
            }

            _isListening = false;
        }
    },

    push: function push(path) {
        try{
            window.history.pushState({
                url: location.href,
                path: path,
                pathname: window.location.pathname,
                'router': 'react-router'
            }, '', path);
            History.length += 1;
            notifyChange(LocationActions.PUSH);
        }catch(e){window.location.href = path;}
    },

    replace: function replace(path) {
        window.history.replaceState({
            url: location.href,
            path: path,
            pathname: window.location.pathname,
            'router': 'react-router'
        }, '', path);
        notifyChange(LocationActions.REPLACE);
    },

    pop: History.back,

    getCurrentPath: function getCurrentPath() {
        return decodeURI(window.location.pathname + window.location.search);
    },

    toString: function toString() {
        return '<HistoryLocation>';
    }

};

module.exports = HistoryLocation;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/HistoryLocation.js
 **/